<template lang="pug">
  app-modal.modalPublicacaoCAF(
    titulo="Publicação",
    :width="width"
    @closeModal="closeModal()"
  )
    template(slot="body")
      el-row
        el-col(:span="12" class="input-container")
          app-label(
            label="Processo:",
            :required="true"
          )
          el-input.input(
            v-model="processo",
            disabled,
          )
        el-col(:span="12" class="input-container")
          app-label(
            label="Interessado:",
            :required="true"
          )
          el-input.input(
            v-model="interessado",
            disabled,
          )
      el-row.margin-top
        el-col(:span="12" class="input-container")
          app-label(
            label="Imóvel:",
            :required="true"
          )
          el-input.input(
            v-model="imovel",
            placeholder="Digite o nome do imóvel"
          )
        el-col(:span="12" class="input-container")
          app-label(
            label="Área (HA):",
            :required="true"
          )
          el-input-number.input(
            v-model="area",
            :min="0",
            :precision="4",
            :controls="false"
            placeholder="Digite a área em hectares"
          )
      el-row.margin-top
        el-col(:span="12" class="input-container")
          app-label(
            label="Localização:",
            :required="true"
          )
          el-input.input(
            v-model="localizacao",
            placeholder="Digite a localização"
          )
        el-col(:span="12" class="input-container")
          app-label(
            label="Município:",
            :required="true"
          )
          el-select.input(
            v-model="municipiosSelected",
            placeholder="Selecione o município",
            clearable,
            filterable,
            multiple,
            no-match-text="Município não encontrado"
          )
            el-option(
              v-for="m in municipios",
              :key="m.id",
              :label="m.nome",
              :value="m.id"
            )
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="closeModal()"
        )
          span.center
            i.fa.fa-times
            b &nbsp CANCELAR
        el-button.btn(
          type="success",
          size="small",
          :disabled="!isValid"
          @click="publicar()"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp PUBLICAR
  </template>

<script>
import axios from '@/utils/api'
import messages from '@/constants/messages'
import AppLabel from '@/components/AppLabel'
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'

export default {
  components: {
    AppModal,
    AppLabel
  },
  mixins: [AppNotificacao],
  props: {
    width: {
      type: Number,
      default: 850
    },
    idProcesso: {
      required: true
    },
    idDespacho: {
      required: true
    }
  },

  data () {
    return {
      processo: '',
      interessado: '',
      imovel: '',
      area: '',
      localizacao: '',
      municipiosSelected: [],
      municipios: []
    }
  },

  computed: {
    isValid () {
      return (
        this.processo &&
        this.interessado &&
        this.imovel &&
        this.area &&
        this.localizacao &&
        this.municipios
      )
    }
  },

  async created () {
    this.getMunicipiosByUf()
    this.buscarDadosPublicacao()
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      getMunicipiosByUf: 'municipios/findMunicipiosByUf'
    }),
    async buscarDadosPublicacao () {
      const response = await axios({
        method: 'GET',
        url: `processo/publicacao/dados/${this.idProcesso}`,
        error: true
      })
      this.processo = response.numeroProcesso
      this.interessado = response.nomeInteressado
      this.imovel = response.nomeImovel
      this.area = response.area
      this.localizacao = response.localizacao
      this.municipiosSelected = this.municipios.filter(m => response.municipios.includes(m.id))?.map(m => m.id)
    },

    closeModal () {
      this.$emit('closeModal')
    },

    confirmarPublicacao () {
      this.$confirm(
        'Ao confirmar, qualquer publicação ativa para este processo será desativada e uma nova publicação será criada.',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      ).then(() => {
        this.publicar()
      }).catch(() => {})
    },

    async publicar () {
      const obj = {
        idProcesso: this.idProcesso,
        idDespacho: this.idDespacho,

        numeroProcesso: this.processo,
        nomeInteressado: this.interessado,
        nomeImovel: this.imovel,
        area: this.area,
        localizacao: this.localizacao,
        municipios: this.municipios.filter(m => this.municipiosSelected.includes(m.id))
      }

      axios({
        method: 'POST',
        url: `publicacao/criar`,
        error: true,
        data: obj
      }).then(() => {
        this.closeModal()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'A publicação foi realizada com sucesso.'
        )
        this.$emit('setHasPublicacao', true)
      }).catch((e) => {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          messages.ERROR_MESSAGE
        )
      })
    },
    async getMunicipiosByUf () {
      this.municipios = await this.$store.dispatch(`municipios/findMunicipiosByUf`, process.env.ESTADO)
    }
  }
}
</script>

<style scoped lang="scss">
.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.input {
  width: 100%;
}

.margin-top {
  margin-top: 20px;
}

.input-container {
  padding-right: 15px;
}

@media (max-width: 780px) {
  .modalPublicacaoCAF {
    width: 360px !important;
    position: fixed !important;
  }

  .input-container {
    padding-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalPublicacao.vue